import {NgModule} from '@angular/core';
import {PmConfigPage} from "./page/overview/pm-config/pm-config.page";
import {PersonSearchComponent} from "./component/protected-components/person-search/person-search.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {
    PmCreatePersonWfProcessStepActivityComponent
} from "./component/protected-components/wf/pm-create-person-wf-process-step-activity/pm-create-person-wf-process-step-activity.component";
import {PmPersonComponent} from "./component/protected-components/pm-person-component/pm-person.component";
import {PmHouseholdComponent} from "./component/protected-components/pm-household/pm-household.component";
import {PmOverviewPage} from "./page/pm-overview-page/pm-overview.page";
import {PmKpiComponent} from "./page/pm-overview-page/components/kpiComponent/pm-kpi.component";
import {PmStatisticsComponent} from "./page/pm-overview-page/components/statisticsComponent/pm-statistics.component";
import {ObjectHouseholdComponent} from "./component/protected-components/object-household/object-household.component";
import {PM_ENTITY_PROVIDER} from "./pm.entity-provider";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {PM_TEST_PROVIDERS} from "./test/pm-test-definition";
import {PM_WF_ACTIVITY_PROVIDER} from "./pm-wf-activity.provider";
import {
    PersonSearchConsultantComponent
} from "./component/protected-components/consultant-component/person-search/person-search-consultant.component";


@NgModule({
    declarations: [
        PmConfigPage,
        PersonSearchComponent,
        PmCreatePersonWfProcessStepActivityComponent,
        PmPersonComponent,
        PmHouseholdComponent,
        PmOverviewPage,
        PmKpiComponent,
        PmStatisticsComponent,
        ObjectHouseholdComponent,
        PersonSearchConsultantComponent,
    ],
    exports: [
        PmConfigPage,
        PersonSearchComponent,
        PmCreatePersonWfProcessStepActivityComponent,
        PmPersonComponent,
        PmHouseholdComponent,
        ObjectHouseholdComponent,
        PersonSearchConsultantComponent,
    ],
    imports: [
        CoreModule,
        ProgressSpinnerModule,
        UiModule,

    ],
    providers: [
        PM_ENTITY_PROVIDER, PM_TEST_PROVIDERS, ...PM_WF_ACTIVITY_PROVIDER
    ]
})
export class PmModule implements DynamicModule {

    alias = 'pm';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return PmKpiComponent;
    }

    getStatisticsComponent() {
        return PmStatisticsComponent;
    }

}


